import { gql } from 'graphql-request';

export const stagesQuery = gql`
  query OpenCallStages($openCallId: String!) {
    stages(openCallId: $openCallId) {
      id
      name
      count
      isDefault
      viewPermissions {
        name
        value
      }
    }
  }
`;

export const mutationCreateStage = gql`
  mutation CreateStage($openCallId: String!) {
    createStage(openCallId: $openCallId) {
      id
      name
      count
      isDefault
      viewPermissions {
        name
        value
      }
    }
  }
`;

export const mutationRenameStage = gql`
  mutation RenameStage(
    $openCallId: String!
    $stageId: String!
    $newName: String!
  ) {
    renameStage(openCallId: $openCallId, stageId: $stageId, newName: $newName) {
      id
      name
      count
      isDefault
      viewPermissions {
        name
        value
      }
    }
  }
`;
